"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ThumbsUpFilledSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M5,8 C5.55228475,8 6,8.44771525 6,9 L6,15 C6,15.5522847 5.55228475,16 5,16 L4,16 C3.44771525,16 3,15.5522847 3,15 L3,9 C3,8.44771525 3.44771525,8 4,8 L5,8 Z M10.5,3 C11.2796961,3 11.9204487,3.59488808 11.9931334,4.35553999 L12,4.5 L11.999,7 L14.4952291,7 C15.2261942,7 15.835041,7.52285085 15.9681819,8.21496507 L15.9883625,8.35553999 L15.9952291,8.5 L15.9890887,8.63558586 L15.9707178,8.77006165 L15.0555577,13.7700616 C14.9338535,14.4349959 14.384931,14.9301325 13.7234282,14.9931955 L13.5800691,15 L7,15 L7,8.29289322 L8.088,7.204 L10.190983,3 L10.5,3 Z" })));
};
ThumbsUpFilledSmall.displayName = 'ThumbsUpFilledSmall';
exports.default = ThumbsUpFilledSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ThumbsUpFilledSmall.js.map